import cn from "classnames"

import { Divider, Space } from "@/atoms"
import * as issueDomain from "@/domain/issue/issue"
import { IssueTypeIcon } from "@/icons"
import { DismissedTag } from "@/molecules/DismissedTag"
import { IssueTag } from "@/molecules/IssueStatusTag"
import { LabelTag } from "@/molecules/LabelTag"

import styles from "./IssueDetails.module.scss"

import type { IssueDetailsComponent } from "."

export const IssueDetails: IssueDetailsComponent = (props) => {
  const {
    severity,
    title,
    description,
    issueType,
    t,
    issueId,
    onAddLabel,
    dismissReason,
    resolutionData,
    discoveredAtInUserLocale,
    resolvedAtInUserLocale,
    status = "open",
    dismissedAt = 0,
    dismissedBy = "",
    dismissMethod = "",
    labels = [],
    isResolved
  } = props
  const issue = {
    status,
    dismissMethod,
    resolutionData,
    dismissedAt,
    discoveredAtInUserLocale,
    resolvedAtInUserLocale,
    id: props.issueId,
    isResolved: isResolved ?? false
  }
  const showDismissTag = issueDomain.isIssueDismissed(issue)
  const showResolvedTag = issueDomain.isIssueResolved(issue)
  const isResolvedInCodeRepo =
    issueDomain.isResolvedInCodeRepoAndNotResolved(issue)
  const showTags = showDismissTag || showResolvedTag || isResolvedInCodeRepo
  const dismissAndResolved = issueDomain.isDismissedAndResolved(issue)

  return (
    <div className={styles.container}>
      {issueType && (
        <IssueTypeIcon
          popover
          size="small"
          t={t}
          type={issueType}
          severity={severity}
        />
      )}
      <div className={styles.textWrapper}>
        <span className={styles.title}>{title}</span>
        <Space
          className={cn(styles.space, showTags && styles.spaceWithTags)}
          separator={
            <Divider orientation="vertical" className={styles.divider} />
          }
        >
          {!!description && (
            <span className={styles.description}>{description}</span>
          )}
          {showTags && (
            <div className={styles.wrapperTags}>
              {showDismissTag && (
                <DismissedTag
                  classes={{
                    tag: cn(
                      styles.dismissedTag,
                      isResolvedInCodeRepo && styles.dismissedTagTruncated
                    )
                  }}
                  issueId={issueId}
                  dismissedBy={dismissedBy}
                  dismissMethod={dismissMethod}
                  timestamp={dismissedAt}
                  reason={dismissReason}
                  title={t("triage.issue")}
                />
              )}
              {isResolvedInCodeRepo && (
                <IssueTag
                  isResolvedInCodeRepo={isResolvedInCodeRepo}
                  record={issue}
                  truncated={dismissAndResolved || showDismissTag}
                />
              )}
              {showResolvedTag && (
                <IssueTag truncated={dismissAndResolved} record={issue} />
              )}
            </div>
          )}
          {!!labels?.length && (
            <LabelTag
              type="tag"
              labels={labels}
              issueId={issueId}
              onAddLabel={onAddLabel}
            />
          )}
        </Space>
      </div>
    </div>
  )
}
